import { uniqueKey } from 'global/common/keys'
import { getSectionColor } from 'projectSpecific/sports/create/sectionColors'
import { useSportsMatches } from 'projectSpecific/sports/useHelpers/useSportsMatches'
import React, { useMemo } from 'react'
import { Label } from 'semantic-ui-react'

export const SectionHeader = ({ levelKey, sectionKey }) => {
  return (
    <div className="match-date-sec sh" key={uniqueKey('mls', 'tm', levelKey, sectionKey)}>
      <div>{_.startCase(sectionKey)}</div>
      {sectionKey && <Label circular size={'tiny'} color={getSectionColor(sectionKey)} />}
    </div>
  )
}

export const LevelHeader = ({ levelKey, matches_level, matchDayResults, gsResults }) => {

  const { getMatchCounts_level } = useSportsMatches()

  const counts = useMemo(() => {
    return getMatchCounts_level({ matches_level, matchDayResults, gsResults })
  }, [matches_level])

  return (
    <div className="level-header header-flexish">
      <div></div>
      <div>{_.startCase(levelKey)}</div>
      <div style={{ display: 'flex' }}>
        {counts.matchDayResults > 0 && <Label size='mini' className='mdr' title={'Match Day Results'}>{counts.matchDayResults}</Label>}
        {counts.gsResults > 0 && <Label size='mini' className='gs' title={'GS Results'}>{counts.gsResults}</Label>}
        {counts.missing > 0 && <Label size='mini' className='miss' title={'Missing'}>{counts.missing}</Label>}
        <Label size='mini' title={'Total'}>{counts.total}</Label>
      </div>
    </div>
  )
}